import { apiFloristGatewayService } from './apiService/HttpService';
import { setEndPoint } from './apiService/SetEndPoint';
import { endPoints } from './apiService/EndPoints';

class TimeSlotsService {
  //production jobs
  static getProductionJobsCount(data, ...extraParams) {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.getProductionJobsCount, ...extraParams),
      params: data,
    });
  }

  static getProductionJobsList(data, ...extraParams) {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.getProductionJobsList, ...extraParams),
      params: data,
    });
  }

  static getAssignProdiuction(data, ...extraParams) {
    return apiFloristGatewayService({
      method: 'PUT',
      url: setEndPoint(endPoints.assignProduction, ...extraParams),
      params: data,
    });
  }

  static getChangeProdiuctionStatus(data, ...extraParams) {
    return apiFloristGatewayService({
      method: 'PUT',
      url: setEndPoint(endPoints.changeProdJobStatus, ...extraParams),
      data,
    });
  }

  static getProdJobDetails(...extraParams) {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.getProdJobDetails, ...extraParams),
    });
  }

  static getProdJobCartDetails(...extraParams) {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.getProdJobCartDetails, ...extraParams),
    });
  }

  static uploadPjQcImage(data, ...extraParams) {
    return apiFloristGatewayService({
      method: 'POST',
      url: setEndPoint(endPoints.uploadQcPjImages, ...extraParams),
      data,
    });
  }

  static getQcImages(...extraParams) {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.getProdJobsQcImages, ...extraParams),
    });
  }

  static getProdJobInventoryDetails(params, ...extraParams) {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.getProdJobInventoryDetails, ...extraParams),
      params,
    });
  }

  static addProdJobDeviation(data, ...extraParams) {
    return apiFloristGatewayService({
      method: 'POST',
      url: setEndPoint(endPoints.addProdJobDeviation, ...extraParams),
      data,
    });
  }
}
export default TimeSlotsService;
